import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.009 11a3 3 0 0 0-3-3h-4.342a4 4 0 0 0-3.976 3.563A115.165 115.165 0 0 0 10 24.07c-.003 4.154.22 8.276.67 12.367A4 4 0 0 0 14.645 40h4.363a3 3 0 0 0 3-3V11Zm-9.33.782A113.18 113.18 0 0 0 12 24.07c-.003 4.08.216 8.13.658 12.147A2 2 0 0 0 14.646 38h4.363a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1h-4.342a2 2 0 0 0-1.988 1.782Zm25.33 12.288a115.169 115.169 0 0 0-.691-12.507A4 4 0 0 0 33.342 8H29a3 3 0 0 0-3 3v26a3 3 0 0 0 3 3h4.363a4 4 0 0 0 3.977-3.563c.449-4.091.672-8.213.669-12.367ZM28 11a1 1 0 0 1 1-1h4.342a2 2 0 0 1 1.988 1.782c.45 4.096.676 8.193.679 12.289.003 4.08-.217 8.13-.658 12.147A2 2 0 0 1 33.363 38H29a1 1 0 0 1-1-1V11Z",
    fill: "currentColor"
  }));
};

var SvgPause = styled(SvgComponent).withConfig({
  displayName: "Pause__SvgPause",
  componentId: "sc-opfi2-0"
})(["", " ", ""], size, color);
export default SvgPause;